module.exports = __webpack_public_path__ + "static/media/placeholder.fa788bb6.svg";